module.exports = __webpack_public_path__ + "img/Josh_Worsfold.e658fb69.png";